export { default as StudentAdd } from './StudentAdd';

